export default "__VITE_ASSET__C66VK_wY__"